// All statuses
const STATUSES = {
    NEW: 'new',
    WAIT_3DS: 'wait_3ds',
    WAIT_ACS: 'wait_acs',
    SUCCESS: 'success',
    FAIL: 'fail'
};
// Statuses related to Card payment type
const CARD_STATUS = {
    NEW: STATUSES.NEW,
    WAIT_3DS: STATUSES.WAIT_3DS,
    WAIT_ACS: STATUSES.WAIT_ACS,
    SUCCESS: STATUSES.SUCCESS,
    FAIL: STATUSES.FAIL
};

export {
    STATUSES,
    CARD_STATUS
};
